import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-confirm-leave-form-modal',
    template: `
    <div class="modal-header">
      <div class="modal-title">
        <fa-icon [icon]="['fas', 'exclamation-triangle']" class="me-2" [fixedWidth]="true"></fa-icon>
        {{ 'modal.confirm-leave-title' | translate }}
      </div>
    </div>

    <div class="modal-body">
      <p class="modal-text">
        {{ 'modal.confirm-leave-body1' | translate }}
      </p>

      <p class="modal-text">
        {{ 'modal.confirm-leave-body2' | translate }}
      </p>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-primary btn-modal" (click)="stay()">
        {{ 'button.confirm-leave-stay' | translate }}
      </button>

      <button type="button" class="btn btn-danger btn-modal" (click)="leave()">
        {{ 'button.confirm-leave-leave' | translate }}
      </button>
    </div>
  `,
    styles: [`
    .modal-header {
      border-bottom: none;
      background-color: #2dbdb6;
      color: #fff;
    }

    .modal-body,
    .modal-footer {
      background-color: #f3f3f3;
    }

    .modal-footer {
      border-top: none;
    }

    .modal-text {
      font-size: 1.05em;
      line-height: 1.6;
      margin: 0 1rem 0.75rem;
    }
  `],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmLeaveFormModalComponent {
  constructor(public activeModal: NgbActiveModal) {}

  public stay(): void {
    this.activeModal.dismiss('stay');
  }

  public leave(): void {
    this.activeModal.close(true);
  }
}